/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon20Solid = forwardRef('MediaUiAPauseIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8 4a1 1 0 0 0-2 0v12a1 1 0 1 0 2 0V4Z" }),
        React.createElement("path", { d: "M14 4a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V4Z" })));
});
